module.exports = __webpack_public_path__ + "img/diseases.8cbfa2e1.svg";